import { dutyonTheme, MantineProvider, ModalsProvider } from "@dutyon/ui-kit";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NuqsAdapter } from "nuqs/adapters/react";
import { type ReactNode, Suspense } from "react";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

interface RootProviderProps {
  children: ReactNode;
}

export function RootProvider({ children }: RootProviderProps) {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <NuqsAdapter>
        <QueryClientProvider client={queryClient}>
          <MantineProvider theme={dutyonTheme}>
            <ModalsProvider>{children}</ModalsProvider>
          </MantineProvider>
        </QueryClientProvider>
      </NuqsAdapter>
    </Suspense>
  );
}
